export class SharedConfig {
}
